import React, {CSSProperties } from "react";
import usePanoramaPopupStore from "../stores/usePanoramaPopupStore";

const st1 = {
  position: "fixed",
  zIndex: 20,
  top: "50px",
  right: 0,
} as CSSProperties;

const st2 = {
  position: "absolute",
  right: "16px",
  border: "none",
  background: "none",
  fontSize: "large",
  fontWeight: "bold",
  padding: "10px 4px",
  cursor: "pointer",
} as CSSProperties;

const PanoramaPopup = () => {
  const { imageUrl, id, isOpen, closePopup, panoramaUrl } = usePanoramaPopupStore();

  if (!isOpen) return null;

  return (
    <div style={st1}>
      <div className="popupStyle">
        <div>
          <div>
            <button
              className="btnStyle"
              style={{ position: "absolute", left: "12px" }}
              onClick={() => {
                if (panoramaUrl)
                  window.open(`/#/panorama?imgurl=${panoramaUrl}`, "_blank");
              }}
            >
              파노라마뷰 보기
            </button>
            <button style={st2} onClick={closePopup}>
              X
            </button>
          </div>
          <img
            alt={`Panorama ${id}`}
            src={imageUrl || "/logo512.png"}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default PanoramaPopup;
